import {getColorStyle} from '@/utilities/color-style-map';
import classNames from 'classnames';

const subscribeLabel = 'Subscribe';
const saveLabel = '& Save';

export type SubscribeAndSaveLabel = {
  /**
   * The highlight color of the 'save' label.
   */
  color?: string;
  /**
   * The percentage of savings. If 0, the percentage will not be displayed.
   */
  percentage?: number;
};

/**
 * Renders a label for the "Subscribe and Save" feature.
 *
 * @param color - The color of the label.
 * @param percentage - The percentage of savings.
 * @returns The rendered label component.
 */
export default function SubscribeAndSaveLabel({
  color = '',
  percentage,
}: SubscribeAndSaveLabel) {
  const colorStyle = getColorStyle(color);
  return (
    <span>
      {subscribeLabel}
      <span
        className={classNames('fast-transition font-bold', colorStyle?.text)}
      >
        {' '}
        {saveLabel} {!!percentage && <span>{percentage}%</span>}
      </span>
    </span>
  );
}
